import React, { useEffect, useState } from "react";
import DashboardLayout from "./DashboardLayout";
import { changePassword } from "./api";
import ActionToast, { ToastAction } from "./ActionToast";

const ChangePassword: React.FC = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [toastAction, setToastAction] = useState<ToastAction | null>(null);

  useEffect(() => {
    if (!toastAction) return;
    const timer = setTimeout(() => setToastAction(null), 6500);
    return () => clearTimeout(timer);
  }, [toastAction]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!oldPassword || !newPassword || !confirmPassword) {
      setErrorMessage("All fields are required.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage("New password and confirm password do not match.");
      return;
    }
    setErrorMessage("");
    setBusy(true);
    try {
      await changePassword(oldPassword, newPassword);
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setToastAction("saved");
    } catch (err: any) {
      setErrorMessage(err.message || "Failed to change password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <DashboardLayout>
      <ActionToast action={toastAction} />
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-4">
          <div className="bg-white border rounded p-3">
            <h4 className="mb-3">Change Password</h4>
            <form onSubmit={onSubmit}>
              <div className="mb-2">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Old password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
              </div>
              <div className="mb-2">
                <input
                  type="password"
                  className="form-control"
                  placeholder="New password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <button type="submit" className="btn btn-primary w-100" disabled={busy}>
                {busy ? "Updating..." : "Update Password"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ChangePassword;
